import { memo } from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Package,
  Users,
  Settings,
  Cookie,
  LogOut,
} from 'lucide-react';

interface SidebarProps {
  onLogout: () => void;
}

const navItems = [
  { to: '/admin', icon: LayoutDashboard, label: '儀表板', end: true },
  { to: '/admin/orders', icon: Package, label: '訂單管理' },
  { to: '/admin/members', icon: Users, label: '會員管理' },
  { to: '/admin/settings', icon: Settings, label: '設定' },
];

const linkBase =
  'flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors';
const linkActive = 'bg-brand-gold/15 text-brand-caramel';
const linkInactive = 'text-gray-500 hover:bg-brand-cream hover:text-gray-700';

export const Sidebar = memo(function Sidebar({ onLogout }: SidebarProps) {
  return (
    <aside className="fixed left-0 top-0 h-full w-64 bg-white border-r border-brand-bake flex flex-col z-40">
      {/* 品牌區 */}
      <div className="h-16 flex items-center gap-3 px-6 border-b border-brand-bake flex-shrink-0">
        <div className="h-9 w-9 rounded-lg bg-brand-gold/20 flex items-center justify-center">
          <Cookie className="h-5 w-5 text-brand-gold" />
        </div>
        <div>
          <h1 className="text-lg font-semibold text-brand-cocoa font-heading">
            怡味屋
          </h1>
          <p className="text-xs text-gray-400 -mt-0.5">管理後台</p>
        </div>
      </div>

      {/* 導航選單 */}
      <nav className="flex-1 px-4 py-6 space-y-1 overflow-y-auto">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `${linkBase} ${isActive ? linkActive : linkInactive}`
            }
          >
            <item.icon className="h-5 w-5 flex-shrink-0" />
            {item.label}
          </NavLink>
        ))}
      </nav>

      {/* 登出按鈕 */}
      <div className="px-4 py-4 border-t border-brand-bake flex-shrink-0">
        <button
          onClick={onLogout}
          className="flex items-center gap-3 w-full px-4 py-3 rounded-lg text-sm font-medium text-gray-400 hover:bg-red-50 hover:text-red-600 transition-colors"
        >
          <LogOut className="h-5 w-5" />
          登出
        </button>
      </div>
    </aside>
  );
});
